import { render, staticRenderFns } from "./activities-search.vue?vue&type=template&id=5ff895c7&scoped=true&"
import script from "./activities-search.vue?vue&type=script&lang=js&"
export * from "./activities-search.vue?vue&type=script&lang=js&"
import style0 from "./activities-search.vue?vue&type=style&index=0&id=5ff895c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff895c7",
  null
  
)

export default component.exports